import {ACTION_CODE} from './_actionCode';
import {ExpenseReportService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'PRINT_EXPENSE_REPORT';

export async function printExpenseReport(
    userData: Record<string, string>,
    id:number
) {
    try {
        LoggerService.logInfo('Action - printExpenseReport - Start');
        console.log(id);
        console.log(userData);
        
        const expenseReport = await ExpenseReportService.downloadExpenseReport(userData, id);

        console.log(expenseReport);
        
        LoggerService.logInfo('Action - printExpenseReport - End - Success');

        return ResultModel.newSuccessResult(expenseReport);
    }
    catch (error) {
        LoggerService.logInfo('Action - printExpenseReport - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
